import React from "react";
import styles from "../../styles/components/skills-hub/Categories.module.scss";
import Link from "next/link";
import { Category } from "../../interfaces";
import Image from "next/image";
import { TFunction } from "next-i18next";
import { images } from "../../constants";

const Categories = (props: Props) => {
  const { t, categories, headingTag = "h2" } = props;
  const Heading = headingTag;
  let filteredCategories = categories?.filter(
    (item) => item.lcCategoryStatus === "PUBLISHED",
  );

  /* 
"Completed Classes" section hidden due to the Meta Boost site being
taken down and SOLS Achieve / English have no content.
Uncomment the array below and the matching JSX block in the return to restore.
const completedCategories = [
  {
    categoryName: "Meta Boost x SOLS Programme",
    categoryLink: "https://metaboost.solsedu.com",
    categoryImage:
      "https://cdn.solssmart.org/sols-edu-classes/skills-hub/meta-boost.png",
  },
  {
    categoryName: "SOLS Achieve",
    categoryLink: "/skills-hub/sols-achieve",
    categoryImage:
      "https://cdn.solssmart.org/sols-edu-classes/skills-hub/sols-achieve.png",
  },
  {
    categoryName: "English",
    categoryLink: "/skills-hub/english",
    categoryImage:
      "https://cdn.solssmart.org/sols-edu-classes/skills-hub/english.png",
  },
]; 
*/

  return (
    <>
      <Heading style={{ padding: "35px 0 5px", fontWeight: "600" }}>
        {t("i-need-to")}
      </Heading>

      <div className={styles.categories}>
        {filteredCategories?.map((category: Category) => (
          <Link
            href={`/skills-hub/${category.lcCategoryId}`}
            key={category.lcCategoryId}
          >
            <span className="card">
              <div className="thumbnail">
                <Image
                  alt={category.lcCategoryName}
                  src={
                    category.lcCategoryImage
                      ? category.lcCategoryImage
                      : images.dummy
                  }
                  width={75}
                  height={60}
                  layout="fixed"
                  priority
                />
              </div>
              <h3 className="name">{category.lcCategoryName}</h3>
            </span>
          </Link>
        ))}
      </div>

      {/* "Completed Classes" section hidden (see note above).
          Uncomment with the `completedCategories` array to restore.
      <h3
        style={{
          borderTop: "1px solid #dddddd",
          margin: "55px 0 0",
          padding: "45px 0 10px",
        }}
      >
        {t("completed-classes")}
      </h3>

      <div className={styles.categories}>
        {completedCategories?.map((category) => (
          <a
            href={category.categoryLink}
            key={category.categoryName}
            target="_blank"
          >
            <span className="card">
              <div className="thumbnail">
                <Image
                  alt={category.categoryName}
                  src={
                    category.categoryImage
                      ? category.categoryImage
                      : images.dummy
                  }
                  width={75}
                  height={60}
                  layout="fixed"
                  priority
                />
              </div>
              <h3 className="name">{category.categoryName}</h3>
            </span>
          </a>
        ))}
      </div>
      */}
    </>
  );
};

interface Props {
  t: TFunction;
  categories: Category[];
  headingTag?: "h2" | "h3";
}

export default Categories;
